import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CommodityCode } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { CommodityCodeService } from '../../services/commodity-code.service';


@Component({
  selector: 'app-commodity-code-dropdown',
  templateUrl: './commodity-code-dropdown.component.html',
  standalone: true,
  imports: [
    CommonModule,
  ],
  providers: [
    CommodityCodeService,
  ],
})
export class CommodityCodeDropdownComponent extends GenericBaseModelDropDown<CommodityCode> {

  constructor(private service: CommodityCodeService) {
    super(service, "CommodityCode");
  }

}
